import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableConsultationFragment = { readonly __typename?: 'SyncableConsultation', readonly id: string, readonly patientId: string, readonly organisationId: string, readonly facilityId: string, readonly diseaseIds?: ReadonlyArray<string> | null, readonly plan?: string | null, readonly problem?: string | null, readonly presentingComplaint?: string | null, readonly symptomIds: ReadonlyArray<string>, readonly isImmunisation?: boolean | null, readonly isPerformedAtOtherClinic?: boolean | null, readonly backdatedTo?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string }, readonly freeTextDiagnoses: ReadonlyArray<{ readonly __typename?: 'FreeTextDiagnosis', readonly id: string, readonly name: string, readonly category: string }> };

export type SyncConsultationPushMutationVariables = Types.Exact<{
  input: Types.PushConsultationInput;
}>;


export type SyncConsultationPushMutation = { readonly __typename?: 'Mutation', readonly pushConsultation: { readonly __typename?: 'PushConsultationResponse', readonly rows: ReadonlyArray<{ readonly __typename?: 'SyncableConsultation', readonly id: string, readonly patientId: string, readonly organisationId: string, readonly facilityId: string, readonly diseaseIds?: ReadonlyArray<string> | null, readonly plan?: string | null, readonly problem?: string | null, readonly presentingComplaint?: string | null, readonly symptomIds: ReadonlyArray<string>, readonly isImmunisation?: boolean | null, readonly isPerformedAtOtherClinic?: boolean | null, readonly backdatedTo?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string }, readonly freeTextDiagnoses: ReadonlyArray<{ readonly __typename?: 'FreeTextDiagnosis', readonly id: string, readonly name: string, readonly category: string }> }> } };

export type SyncConsultationPullQueryVariables = Types.Exact<{
  input: Types.PullConsultationInput;
}>;


export type SyncConsultationPullQuery = { readonly __typename?: 'Query', readonly pullConsultation: { readonly __typename?: 'PullConsultationResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableConsultation', readonly id: string, readonly patientId: string, readonly organisationId: string, readonly facilityId: string, readonly diseaseIds?: ReadonlyArray<string> | null, readonly plan?: string | null, readonly problem?: string | null, readonly presentingComplaint?: string | null, readonly symptomIds: ReadonlyArray<string>, readonly isImmunisation?: boolean | null, readonly isPerformedAtOtherClinic?: boolean | null, readonly backdatedTo?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly deleted: boolean, readonly updatedAt: string, readonly createdAt: string, readonly updatedByUserId: string, readonly createdByUserId: string }, readonly freeTextDiagnoses: ReadonlyArray<{ readonly __typename?: 'FreeTextDiagnosis', readonly id: string, readonly name: string, readonly category: string }> }> } };

export const WholeSyncableConsultationFragmentDoc = gql`
    fragment WholeSyncableConsultation on SyncableConsultation {
  id
  patientId
  organisationId
  facilityId
  meta {
    deleted
    updatedAt
    createdAt
    updatedByUserId
    createdByUserId
  }
  freeTextDiagnoses {
    id
    name
    category
  }
  diseaseIds
  plan
  problem
  presentingComplaint
  symptomIds
  isImmunisation
  isPerformedAtOtherClinic
  backdatedTo
}
    `;
export const SyncConsultationPushDocument = gql`
    mutation SyncConsultationPush($input: PushConsultationInput!) {
  pushConsultation(input: $input) {
    rows {
      ...WholeSyncableConsultation
    }
  }
}
    ${WholeSyncableConsultationFragmentDoc}`;
export type SyncConsultationPushMutationFn = Apollo.MutationFunction<SyncConsultationPushMutation, SyncConsultationPushMutationVariables>;

/**
 * __useSyncConsultationPushMutation__
 *
 * To run a mutation, you first call `useSyncConsultationPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncConsultationPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncConsultationPushMutation, { data, loading, error }] = useSyncConsultationPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncConsultationPushMutation(baseOptions?: Apollo.MutationHookOptions<SyncConsultationPushMutation, SyncConsultationPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncConsultationPushMutation, SyncConsultationPushMutationVariables>(SyncConsultationPushDocument, options);
      }
export type SyncConsultationPushMutationHookResult = ReturnType<typeof useSyncConsultationPushMutation>;
export type SyncConsultationPushMutationResult = Apollo.MutationResult<SyncConsultationPushMutation>;
export type SyncConsultationPushMutationOptions = Apollo.BaseMutationOptions<SyncConsultationPushMutation, SyncConsultationPushMutationVariables>;
export const SyncConsultationPullDocument = gql`
    query SyncConsultationPull($input: PullConsultationInput!) {
  pullConsultation(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableConsultation
    }
  }
}
    ${WholeSyncableConsultationFragmentDoc}`;

/**
 * __useSyncConsultationPullQuery__
 *
 * To run a query within a React component, call `useSyncConsultationPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncConsultationPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncConsultationPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncConsultationPullQuery(baseOptions: Apollo.QueryHookOptions<SyncConsultationPullQuery, SyncConsultationPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncConsultationPullQuery, SyncConsultationPullQueryVariables>(SyncConsultationPullDocument, options);
      }
export function useSyncConsultationPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncConsultationPullQuery, SyncConsultationPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncConsultationPullQuery, SyncConsultationPullQueryVariables>(SyncConsultationPullDocument, options);
        }
export type SyncConsultationPullQueryHookResult = ReturnType<typeof useSyncConsultationPullQuery>;
export type SyncConsultationPullLazyQueryHookResult = ReturnType<typeof useSyncConsultationPullLazyQuery>;
export type SyncConsultationPullQueryResult = Apollo.QueryResult<SyncConsultationPullQuery, SyncConsultationPullQueryVariables>;